import * as React from 'react';
import {Query} from 'react-apollo';
import {connect} from 'react-redux';

import gql from 'graphql-tag';

import type {GetPersistedListParams as GetPersistedListParamsQuery} from 'nutshell-graphql-types';

import {EntityList} from '../entity-list';

const GET_PERSISTED_PARAMS = gql`
    query GetPersistedListParams {
        accounts: setting(settingName: "entity_list_accounts_persisted_url") {
            id
            value
        }
        contacts: setting(settingName: "entity_list_contacts_persisted_url") {
            id
            value
        }
        leads: setting(settingName: "entity_list_leads_persisted_url") {
            id
            value
        }
    }
`;

type OwnProps = {
    children: (arg1?: any) => React.ReactElement;
};

type DispatchProps = {
    loadDefaults: (arg1: GetPersistedListParamsQuery) => void;
};

type Props = OwnProps & DispatchProps;

// @ts-expect-error
function mapDispatchToProps(dispatch): DispatchProps {
    return {
        loadDefaults: (defaultParams) => {
            dispatch(EntityList.loadPersistedParams(defaultParams));
        },
    };
}

class GetPersistedQuery extends Query<GetPersistedListParamsQuery, Record<any, any>> {}

export const PersistedQueryParamsComponent = ({children, loadDefaults, ...otherProps}: Props) => (
    <GetPersistedQuery
        query={GET_PERSISTED_PARAMS}
        onCompleted={(data) => {
            loadDefaults(data);
        }}
    >
        {() => children(otherProps)}
    </GetPersistedQuery>
);

// @ts-expect-error
const connector = connect<Props, OwnProps, _, _, _, _>(null, mapDispatchToProps);

export const PersistedQueryParams = connector(PersistedQueryParamsComponent);
